/*
 * Keebio custom JS
 * Removes orphaned bundle-child line items (a bundle child whose parent
 * was removed from the cart) on theme:cart:change.
 */
(function () {
  'use strict';
  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (!cart) return;
    for (const item of cart.items) {
      if ('_bundle_child' in item.properties && item.properties['_bundle_child'] == 'true') {
        const parentItem = cart.items.find(i =>
          i.id !== item.id &&
          i.properties['_bundle_id'] === item.properties['_bundle_id'] &&
          '_is_bundle_parent' in i.properties &&
          i.properties['_is_bundle_parent'] == 'true'
        );
        if (!parentItem) {
          // Remove the orphaned child item from cart
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          })
            .then(response => response.json())
            .then(() => {
              // TODO(perf, needs testing): replace the full reload with a targeted
              // dp:cart:updated re-render — only once verified to refresh the header
              // count, mini-cart, drawer, AND cart page together. reload() is blunt
              // but complete; kept until the event path is tested.
              window.location.reload();
            })
            .catch(error => {
              console.error('Error removing orphaned bundle child:', error);
            });
          continue;
        }
      }
    }
  });
})();
